import React, { useState } from 'react';
import moment from 'moment';
import { Grid } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import {
  TextField,
  GridForm,
  Select,
  Button,
} from '../lib/common';

const ages = Array(30).fill(0).map((_, i) => i + 50);

const PropspectForm = (props) => {
  const {
    update,
  } = props;
  const [client, setClient] = useState({
    ...props.client,
  });

  const handleTextChange = (e) => {
    const { name, value } = e.target || e;
    const updatedClient = { ...client, [name]: value };
    update(updatedClient);
    setClient(updatedClient);
  };
  const {
    firstname,
    lastname,
    dob,
    retirement_age,
    spouse_firstname,
    spouse_lastname,
    spouse_dob,
    spouse_retirement_age,
    addSpouse,
  } = client;

  return (
    <GridForm>
      <Grid container spacing={2}>
        <TextField
          name="firstname"
          label="First Name"
          value={firstname}
          required
          onChange={handleTextChange}
        />
        <TextField
          label="Last Name"
          name="lastname"
          value={lastname}
          required
          onChange={handleTextChange}
        />
        <TextField
          label="Date of Birth"
          value={dob}
          name="dob"
          onChange={(e) => {
            const { name, value } = e.target;
            const formattedValue = moment(value).toISOString();
            const updatedClient = { ...client, [name]: formattedValue };
            update(updatedClient);
            setClient(updatedClient);
          }}
          type="date"
          required
          xs={3}
        />
        <Select
          label="Desired retirement Age"
          value={retirement_age}
          name="retirement_age"
          onChange={handleTextChange}
          required
        >
          {ages.map((age) => (
            <MenuItem key={age} value={age}>{age}</MenuItem>
          ))}
        </Select>
      </Grid>
      {addSpouse ? (
        <Grid container spacing={2}>
          <TextField
            label="Spouse First Name"
            name="spouse_firstname"
            value={spouse_firstname}
            onChange={handleTextChange}
          />
          <TextField
            label="Spouse Last Name"
            name="spouse_lastname"
            value={spouse_lastname}
            onChange={handleTextChange}
          />
          <TextField
            label="Spouse Date of Birth"
            value={spouse_dob}
            name="spouse_dob"
            onChange={(e) => {
              const { name, value } = e.target;
              const formattedValue = moment(value).toISOString();
              const updatedClient = { ...client, [name]: formattedValue };
              update(updatedClient);
              setClient(updatedClient);
            }}
            type="date"
            xs={3}
          />
          <Select
            label="Desired retirement Age"
            value={spouse_retirement_age}
            name="spouse_retirement_age"
            onChange={handleTextChange}
            required
          >
            {ages.map((age) => (
              <MenuItem key={age} value={age}>{age}</MenuItem>
            ))}
          </Select>
        </Grid>
      ) : (
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            const updatedClient = { ...client, addSpouse: true };
            update(updatedClient);
            setClient(updatedClient);
          }}
        >
          Add Spouse
        </Button>
      )}
      
    </GridForm>
  );
};

export default PropspectForm;
